// extracted by mini-css-extract-plugin
export var ArticleListContainer = "ArticleList-module--ArticleListContainer--xVTop";
export var ArticleListTitle = "ArticleList-module--ArticleListTitle--XCkeB";
export var articles = "ArticleList-module--articles--m5IrV";
export var caseStudyContainer = "ArticleList-module--caseStudyContainer--uiHVk";
export var limitWidthOnLargeScreens = "ArticleList-module--limitWidthOnLargeScreens--PFvMw";
export var viewMoreButton = "ArticleList-module--viewMoreButton--B62+H";